exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".link[data-v-1bf60cf8]{color:#409eff;padding:5px 10px;cursor:pointer}", "", {"version":3,"sources":["/workspace/src/views/group-batch/pages/GroupBatchCustomerTable.vue"],"names":[],"mappings":"AACA,uBAAuB,cAAc,iBAAiB,cAAc,CACnE","file":"GroupBatchCustomerTable.vue","sourcesContent":["\n.link[data-v-1bf60cf8]{color:#409EFF;padding:5px 10px;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bf60cf8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/group-batch/pages/GroupBatchCustomerTable.vue
// module id = 4070
// module chunks = 280